<div class="filters-bar">

  <ng-template #filter>
    <div class="row no-gutters">
      <div class="col-sm-12 col-md-12 col-lg-3">
        <mat-icon *ngIf="!uiService.isLeftSidePanelVisible" matTooltip="Open left sidepanel" class="return-button"
          (click)="uiService.showLeftSidePanel()" svgIcon="menu"></mat-icon>
        <input type="text" [clickOutside]="[]" [isToChangeFocus]="true" class="filter-search" placeholder="Filter"
          [(ngModel)]="nameFilter" matTooltip="Filter">
      </div>

      <div class="col-sm-12 col-md-12 col-lg-6">
        <div class="col pt-0 pl-0">
          <ng-select [(ngModel)]="locationFilter" [multiple]="false" [items]="locations" class="custom" [searchable]="false"
            [markFirst]="false" [clearable]="false" placeholder="Select filter">

            <ng-template ng-label-tmp let-item="item">
              {{item.Title}}
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <p [matTooltip]="item?.Title" (click)="setCurrentLocation(item)">{{item.Title}}</p>
              <div class="location-item">
                <mat-checkbox (click)="$event.stopPropagation()" (ngModelChange)="onShowPrimaryChanged(item)"
                  (change)="onChangeCheck()" [(ngModel)]="item.ShowPrimaryScreen" [disableRipple]="true">Show primary
                </mat-checkbox>
              </div>
            </ng-template>

          </ng-select>
        </div>

        <div class="col pt-0 pl-0">
          <ng-select
            [(ngModel)]="categoryFilter"
            [multiple]="true"
            [items]="categories$ | async"
            [searchable]="false"
            [markFirst]="false"
            [clearable]="false"
            [deselectOnClick]="false"
            (change)="setCurrentCategory($event)"
            class="category-select"
            placeholder="Select a category">

            <ng-template ng-multi-label-tmp let-items="items">
              <div *ngIf="!!items?.length" class="ng-summary-list">
                <div class="ng-value">
                  <div *ngIf="items[0].Color as categoryColor"
                    class="category-color ml-0" [ngStyle]="{ 'background': categoryColor }"></div>
                  <span class="ng-value-label">
                    {{ items[0].Name }} {{ items.length > 1 ? ' + ' + (items.length - 1).toString() + ' more' : '' }}
                  </span>
                </div>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex align-items-center category-item">
                <mat-checkbox *ngIf="item.Id" class="multi-checkbox ml-2"
                  [disableRipple]="true"
                  (click)="$event.stopPropagation()"
                  (change)="onChangeMultiple($event.checked, item)"
                  [checked]="categoryFilter | arrayContainsElement: item: 'Id'">
                </mat-checkbox>
                <div *ngIf="item.Color" class="category-color" [ngStyle]="{ 'background': item.Color }"></div>
                <p matTooltip="{{ item.Name }} {{ item.Description ? ' - ' + item.Description : '' }}">
                  {{ item.Name }}
                </p>
              </div>
            </ng-template>

          </ng-select>
        </div>


        <button mat-icon-button class="d-none d-lg-block ml-lg-2 ml-xl-3" [disableRipple]="true">
          <mat-slide-toggle [checked]="isIdentifyEnabled" (change)="onIdentifyChange($event)"
            matTooltip="Identify screens"></mat-slide-toggle>
        </button>

        <mat-checkbox class="d-none d-lg-block ml-lg-2 overflow-hidden identify-checkbox"
          [ngStyle]="{ 'visibility': isIdentifyEnabled ? 'visible' : 'hidden' }" [checked]="isSimplifiedIdentifyEnabled"
          (ngModelChange)="onShowPrimaryChanged(item)" (change)="enableIdentify($event.checked, true)"
          [disableRipple]="true">Screen names only
        </mat-checkbox>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-3 d-none d-md-flex pr-0">
        <div class="ml-auto py-0">

          <button mat-icon-button class="d-block d-lg-none" [disableRipple]="true">
            <mat-slide-toggle [checked]="isIdentifyEnabled" (change)="onIdentifyChange($event)">
            </mat-slide-toggle>
          </button>

          <mat-checkbox class="d-block d-lg-none ml-lg-2 overflow-hidden identify-checkbox"
            [ngStyle]="{ 'visibility': isIdentifyEnabled ? 'visible' : 'hidden' }" [checked]="isSimplifiedIdentifyEnabled"
            (ngModelChange)="onShowPrimaryChanged(item)" (change)="enableIdentify($event.checked, true)"
            [disableRipple]="true">
          </mat-checkbox>

          <mat-icon matTooltip="Restart and refresh all screens in the current selection view" svgIcon="refresh" (click)="relaunchClient()"
            matTooltipClass="long-tooltip" *ngIf="!isRelaunching; else loadingSpinner"></mat-icon>
          <ng-template #loadingSpinner>
            <mat-spinner [diameter]="20"></mat-spinner>
          </ng-template>

          <mat-icon matTooltip="Scheduler View" svgIcon="today" (click)="viewMode= viewModes.Calendar"
            [class.active]="viewMode == viewModes.Calendar"></mat-icon>

          <mat-icon *ngIf="viewMode == viewModes.FullScreen; else grayImageFullScreen" svgIcon="full_screen_active">
          </mat-icon>
          <ng-template #grayImageFullScreen>
            <mat-icon svgIcon="full_screen" matTooltip="Full Screen View" (click)="onFullScreenClick()"></mat-icon>
          </ng-template>

          <mat-icon *ngIf="viewMode == viewModes.Monitors; else grayImageMonitors" svgIcon="view_comfy_active">
          </mat-icon>
          <ng-template #grayImageMonitors>
            <mat-icon svgIcon="view_comfy" matTooltip="Detail Snapshot View" (click)="onDetailScreenClick()"></mat-icon>
          </ng-template>

          <mat-icon *ngIf="viewMode == viewModes.MonitorsSmall; else grayImageMonitorsSmall"
            svgIcon="view_comfy_small_active">
          </mat-icon>
          <ng-template #grayImageMonitorsSmall>
            <mat-icon svgIcon="view_comfy_small" (click)="onMonitorsSmallClick()" matTooltip="Snapshot View">
            </mat-icon>
          </ng-template>

          <mat-icon *ngIf="viewMode == viewModes.List; else grayImageList" svgIcon="list_active">
          </mat-icon>
          <ng-template #grayImageList>
            <mat-icon svgIcon="list" (click)="onMonitorsListClick()" matTooltip="List View">
            </mat-icon>
          </ng-template>


          <mat-icon *ngIf="!uiService.isRightSidePanelVisible" matTooltip="Open playboard"
            (click)="uiService.showRightSidePanel()" svgIcon="menu" class="return-button"></mat-icon>
        </div>
      </div>

    </div>

  </ng-template>

  <div class="rm-warning-card" *ngIf="remoteControlMonitorKey$ | async; else filter">
    <div class="rm-warning-card-wrapper">
      <div class="rm-warning-card-icon">
        <mat-icon class="playlist-icon" svgIcon="priority_high_small"></mat-icon>
      </div>
    </div>
    <p>Press <b>Ctrl + Alt + Q</b> to close the remote control</p>
  </div>
</div>
